// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useRef } from 'react';
import { fireNonCancelableEvent } from '../../internal/events';
export const useLoadItems = ({ onLoadItems, items, statusType }) => {
    const prevFilteringText = useRef(undefined);
    const fireLoadItems = (filteringText) => {
        // Without a handler nothing is requested, so the text must not count as requested either:
        // otherwise a handler attached later would have its first request deduplicated away.
        if (!onLoadItems || prevFilteringText.current === filteringText) {
            return;
        }
        prevFilteringText.current = filteringText;
        fireNonCancelableEvent(onLoadItems, { filteringText, firstPage: true, samePage: false });
    };
    const handleLoadMore = () => {
        const firstPage = items.length === 0;
        if (statusType === 'pending') {
            fireNonCancelableEvent(onLoadItems, {
                firstPage,
                samePage: false,
                filteringText: prevFilteringText.current || '',
            });
        }
    };
    // Events about an expandable group never carry the root filtering text: the filter applies to
    // the root list, while a group is always loaded as a whole.
    const handleRecoveryClick = (expandedGroupId) => fireNonCancelableEvent(onLoadItems, {
        firstPage: false,
        samePage: true,
        filteringText: expandedGroupId ? '' : prevFilteringText.current || '',
        expandedGroupId,
    });
    const fireGroupLoadItems = (expandedGroupId) => fireNonCancelableEvent(onLoadItems, { filteringText: '', firstPage: true, samePage: false, expandedGroupId });
    return {
        fireLoadItems,
        handleLoadMore,
        handleRecoveryClick,
        fireGroupLoadItems,
    };
};
//# sourceMappingURL=use-load-items.js.map